import React from 'react';

const Logo = ({ size = 32, style = {} }) => (
  <img
    src="/LegacyRootslogo.png"
    alt="LegacyRoots"
    width={size}
    height={size}
    style={{ display: 'block', objectFit: 'contain', ...style }}
  />
);

export default Logo;
